import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, Users, Award } from 'lucide-react';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 text-gray-900">
            {t('about.title')}
          </h1>

          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 mb-8">
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              {t('about.content')}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="text-center p-6 bg-red-50 rounded-lg">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Calendar className="text-white" size={32} />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900">{t('about.founding')}</h3>
                <p className="text-gray-700">{t('about.foundingYear')}</p>
              </div>

              <div className="text-center p-6 bg-red-50 rounded-lg">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="text-white" size={32} />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900">{t('about.membership')}</h3>
                <p className="text-gray-700">{t('about.membershipInfo')}</p>
              </div>

              <div className="text-center p-6 bg-red-50 rounded-lg">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="text-white" size={32} />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900">{t('about.activities')}</h3>
                <p className="text-gray-700">{t('about.activitiesInfo')}</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-lg shadow-lg p-8 md:p-12">
            <img
              src="https://customer-assets.emergentagent.com/job_f40446d8-d7d2-4086-ac19-be3f085557d2/artifacts/2lbvgq55_Cane%20Corso%20Logo-05.png"
              alt="Cane Corso Logo"
              className="w-32 h-32 mx-auto mb-6 object-contain"
            />
            <p className="text-center text-lg leading-relaxed">
              Türkiye'de Cane Corso ırkının gelişimi ve korunması için çalışan, FCI standartlarına bağlı resmi dernektir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
